import { LoadingLogo } from "@/components/shared/LoadingLogo";
import { cn } from "@/lib/utils";

interface LoadingPageProps {
  /** Use when the loading state is inside a layout with sidebar (e.g. dashboard). */
  className?: string;
}

/**
 * Full-page loading state. Use whenever a page is loading its main data so users
 * see the branded loading experience instead of a plain "Loading…" title or text.
 * Renders a centered LoadingLogo with consistent min-height.
 */
export function LoadingPage({ className }: LoadingPageProps): JSX.Element {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading"
      className={cn(
        "flex min-h-full flex-1 items-center justify-center",
        className
      )}
    >
      <LoadingLogo size="lg" />
    </div>
  );
}
